module.exports = __webpack_public_path__ + "static/img/img-home-co-07.4f96c88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-co-07.png
// module id = f0tJ
// module chunks = 1